import { useState } from "react";
import { Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";

const links = [
  { label: "Book Us", href: "#hire-us" },
  { label: "Services", href: "#services" },
  { label: "Join Our Crew", href: "#jobs" },
  { label: "Contact", href: "#contact" },
];

export const Navbar = () => {
  const [open, setOpen] = useState(false);
  return (
    <header className="sticky top-0 z-50 bg-white/80 backdrop-blur-xl border-b border-slate-200/60 shadow-sm" data-testid="main-navbar">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8 h-16 sm:h-20 flex items-center justify-between">
        <a href="#top" data-testid="navbar-logo-link" className="flex items-center">
          <img src="/assets/prgl-logo.png" alt="PRGL - Van & Crew Delivery Specialists" className="h-9 sm:h-11 w-auto" />
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a key={l.href} href={l.href} data-testid={`navbar-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className="text-sm font-medium text-slate-600 hover:text-blue-700 transition-colors duration-200">
              {l.label}
            </a>
          ))}
          <Button asChild data-testid="navbar-hire-staff-btn" className="bg-blue-600 hover:bg-blue-700 text-white rounded-md">
            <a href="#hire-us">Book Now</a>
          </Button>
        </nav>
        <button className="md:hidden p-2 text-slate-700" data-testid="navbar-mobile-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden bg-white border-t border-slate-200 px-6 py-4 flex flex-col gap-4" data-testid="navbar-mobile-menu">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}
              className="text-base font-medium text-slate-700 hover:text-blue-700 transition-colors">{l.label}</a>
          ))}
          <Button asChild className="bg-blue-600 hover:bg-blue-700 text-white w-full">
            <a href="#hire-us" onClick={() => setOpen(false)}>Book Now</a>
          </Button>
        </nav>
      )}
    </header>
  );
};
